import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { NotificationChannel } from '../db/UserNotification.js';
import { buildAnswerFeedback } from '../server/answer-feedback.js';
import { requireAnswerableNotification } from '../server/notification-access.js';
import { processNotificationAnswer } from '../server/processNotificationAnswer.js';

/**
 * Answer a single notification, by option and/or in free text. The option path applies its
 * patch deterministically; free text is read by the model and only applied when that reading
 * is confident enough (see `processNotificationAnswer`).
 */
export const answerNotification = registerMutation({
  type: () => String,
  operationName: 'answerNotification',
  resolve: (notificationID: string, optionKey?: string, freeText?: string) => {
    return async () => {
      const handle = await requireAnswerableNotification(notificationID);
      const outcome = await processNotificationAnswer(handle, {
        optionKey: optionKey ?? null,
        freeText: freeText ?? null,
        channel: NotificationChannel.DASHBOARD,
        answeredByUserID: handle.userID,
      });
      return buildAnswerFeedback(outcome);
    };
  },
  params: [
    { name: 'notificationID', type: () => String },
    { name: 'optionKey', type: () => String },
    { name: 'freeText', type: () => String },
  ],
});
